import {
  Modal,
  Form,
  FormGroup,
  ModalHeader,
  Col,
  Label,
  Input,
} from "reactstrap";
import 'assets/css/admin_user_filters_modal.css'

import React, { useState } from 'react';
import { useFormik } from "formik";
import Select from "react-select";
import { getJsonStringForFilters, getOptionFromValueForSelectBox, getPrimaryButtonClass } from "helpers/sf_utils";
import { WHITELABELED_BRANDS_FILTERED_COLUMNS_OBJECTS, LEADS_STATUS_OPTIONS, COMPARISON_FIELD_OPTIONS } from 'helpers/sf_constants';
import { useMemo } from "react";
import NumberFormat from "react-number-format";

const filtersForWhitelabeledBrandsUsers = Object.values(WHITELABELED_BRANDS_FILTERED_COLUMNS_OBJECTS)
const STATUS_OPTIONS = [
  {label: "Active", value: "Active"},
  {label: "Paused", value: "Paused"}
]

const WhitelistedBrandUsersFilterModal = ({ isActive, modalState, onSubmitModalState, onClickModalClose, brandOptions }) => {

  const [selectedFilterName, setSelectedFilterName] = useState('');
  const [selectedStatus, setSelectedStatus] = useState(getOptionFromValueForSelectBox(LEADS_STATUS_OPTIONS, modalState?.status_value) || null);
  const [selectedIdState, setSelectedIdState] = useState(getOptionFromValueForSelectBox(COMPARISON_FIELD_OPTIONS, modalState?.id_state_value) || null);
  const [selectedBrand, setSelectedBrand] = useState(getOptionFromValueForSelectBox(brandOptions, modalState?.brand_value) || null);

  const searchFilters = useMemo(() => {
    let filtersOfFilters = filtersForWhitelabeledBrandsUsers.map(single => single.fieldName)
    if (selectedFilterName.length > 0) {
      filtersOfFilters = filtersOfFilters.filter((single_object, index) => filtersForWhitelabeledBrandsUsers[index]?.name?.toLowerCase().includes(selectedFilterName.toLowerCase()))
    }
    return filtersOfFilters
  }, [selectedFilterName])

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      ...modalState
    },
    onSubmit: (values, { resetForm }) => {
      onSubmitModalState({
        ...values,
        status_value: getJsonStringForFilters(selectedStatus),
        brand_value: getJsonStringForFilters(selectedBrand),
        id_state_value: selectedIdState?.value || "",
      });
    }
  });

  const handleBrandChange = (selectedObj) => {
    setSelectedBrand(selectedObj);
  }

  const handleStatusChange = (selectedObj) => {
    setSelectedStatus(selectedObj);
  }

  return (

    <Modal className="filter admin-filter-users"
      isOpen={isActive}
      backdrop={true}
      fade={false}
      backdropClassName="no-backdrop-color"
      toggle={onClickModalClose}
      scrollable={true}
    >
      <ModalHeader>
        <span className="modal-title text-black">Filters</span>
        <button type="button" className="close" onClick={onClickModalClose} data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </ModalHeader>
      <div className="sf-admin-filters-position-relative">
        <Form onSubmit={e => {
          e.preventDefault()
          validation.handleSubmit()
          return false
        }}>
          <div className="mx-3" style={{ minHeight: '50vh' }}>
            <Col md="auto" className='align-self-center mt-3'>
              <FormGroup className="mb-0">
                <div className="search-box me-2 d-inline-block">
                  <div className="position-relative">
                    <Input
                      className="rounded sf-box-w"
                      value={selectedFilterName}
                      placeholder="Search Filters"
                      onChange={(e) => {
                        setSelectedFilterName(e.target.value);
                      }}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault()
                        }
                      }}
                    />
                    <i className="bx bx-search-alt search-icon" />
                  </div>
                </div>
              </FormGroup>
            </Col>
            {searchFilters.includes(WHITELABELED_BRANDS_FILTERED_COLUMNS_OBJECTS.ID.fieldName) &&
              <FormGroup className="" id="user-filter-rebill_amount" row check>
                <Col sm={12} >
                  <Input
                    id="user-rebill_amount"
                    type="checkbox"
                    name="id"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.id}
                    defaultChecked={validation.values.id}
                  />
                  {' '}
                  <Label htmlFor="user-rebill_amount" check>
                    ID
                  </Label>
                </Col>
                {(validation.values.id) && (<>
                  <Col sm={12} className="mt-2">
                    <Select
                      id="user-rebill_amount"
                      name="id"
                      options={COMPARISON_FIELD_OPTIONS}
                      onChange={(option) => setSelectedIdState(option)}
                      value={selectedIdState}
                    />
                  </Col>
                  {(validation.values.id) && selectedIdState?.value && (<>
                    <Col sm={12} className="mt-2 mb-2">
                      <NumberFormat
                        className="form-control"
                        type="text"
                        name="id_value"
                        autoComplete="off"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        onKeyDown={validation.handleKeyDown}
                        value={validation.values.id_value}
                        allowEmptyFormatting={true}
                      />
                    </Col>
                  </>)}
                </>)}
              </FormGroup>}
              {searchFilters.includes(WHITELABELED_BRANDS_FILTERED_COLUMNS_OBJECTS.STATUS.fieldName) &&
              <FormGroup className="" id="user-status" row check>
                <Col sm={12}>
                  <Input
                    id="user-filter-status"
                    type="checkbox"
                    name="status"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.status}
                    defaultChecked={validation.values.status}
                  />
                  {' '}
                  <Label htmlFor="user-filter-status" check>
                    Status
                  </Label>
                </Col>

                {(validation.values.status) && (<>
                  <Col sm={12} className="mt-2 mb-2">
                    <Select
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      id="user-filter-status-value"
                      name="status_value"
                      options={STATUS_OPTIONS}
                      onChange={handleStatusChange}
                      onBlur={validation.handleBlur}
                      value={selectedStatus}
                      isMulti={true}
                    />
                  </Col>
                </>)}
              </FormGroup>}
            {searchFilters.includes(WHITELABELED_BRANDS_FILTERED_COLUMNS_OBJECTS.NAME.fieldName) &&
              <FormGroup className="" id="user-first_name" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-first-name"
                    type="checkbox"
                    name="name"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name}
                    defaultChecked={validation.values.name}
                  />
                  {' '}
                  <Label htmlFor="user-filter-first-name" check>
                    Name
                  </Label>
                </Col>
                {(validation.values.name) && (<>
                  <Col sm={12} className="mt-2 mb-2">
                    <Input
                      id="user-filter-first-name-value"
                      type="text"
                      name="name_value"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.name_value}
                    />
                  </Col>
                </>)}
              </FormGroup>}

            {searchFilters.includes(WHITELABELED_BRANDS_FILTERED_COLUMNS_OBJECTS.EMAIL.fieldName) &&
              <FormGroup className="" id="user-email" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-email"
                    type="checkbox"
                    name="email"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.email}
                    defaultChecked={validation.values.email}
                  />
                  {' '}
                  <Label htmlFor="user-filter-email" check>
                    Email
                  </Label>
                </Col>
                {(validation.values.email) && (<>
                  <Col sm={12} className="mt-2 mb-2">
                    <Input
                      id="user-filter-first-name-value"
                      type="text"
                      name="email_value"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.email_value}
                    />
                  </Col>
                </>)}
              </FormGroup>}

            {searchFilters.includes(WHITELABELED_BRANDS_FILTERED_COLUMNS_OBJECTS.BRAND.fieldName) &&
              <FormGroup className="" id="user-state" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-state"
                    type="checkbox"
                    name="brand"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.brand}
                    defaultChecked={validation.values.brand}
                  />
                  {' '}
                  <Label htmlFor="user-filter-state" check>
                    Brand
                  </Label>
                </Col>

                {(validation.values.brand) && (<>
                  <Col sm={12} className="mt-2 mb-2">
                    <Select
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      id="user-filter-first-name-value"
                      name="state_value"
                      options={brandOptions}
                      onChange={handleBrandChange}
                      onBlur={validation.handleBlur}
                      value={selectedBrand}
                      isMulti={true}
                    />
                  </Col>
                </>)}
              </FormGroup>}

          </div>
          <div className="modal-footer d-flex flex-wrap bg-white sf-admin-filters-position-sticky gap-2 pt-3">
            <button className={`btn ${getPrimaryButtonClass()} btn-sm`} type="submit">Update</button>
            <button className="btn btn-light btn-sm" type="reset" onClick={onClickModalClose}>Cancel</button>
          </div>
        </Form>
      </div>
    </Modal>
  )
}

export default WhitelistedBrandUsersFilterModal;